import constants from 'constants/index'

const statusDriverId = (status) => {
  return constants.questionControl.QUESTION_DRIVER_STATUS_ID[status] || ''
}

export default statusDriverId
